import { useQuery } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { ZervantLocale } from '../enums/zervantLocale'
import { fetchInvoiceEmailTemplate } from '../query-api'
import { InvoiceEmailTemplateDocumentType } from '../types/invoices/invoinceEmailTemplateDocumentType'

export const useFetchInvoiceEmailTemplate = (
  emailTemplateType: InvoiceEmailTemplateDocumentType,
  invoiceLocale: ZervantLocale,
) => {
  const { data, ...rest } = useQuery(
    QueryKeys.InvoiceZervantEmailTemplate,
    () => fetchInvoiceEmailTemplate(emailTemplateType, invoiceLocale),
    { enabled: !!emailTemplateType && !!invoiceLocale },
  )

  return { invoiceEmailTemplate: data?.data, ...rest }
}
